import { Brain } from "lucide-react";

import { Input } from "@/components/ui/input";
import type { Assistant } from "../../api";
import SettingsSheet from "./SettingsSheet";
import { Field, SliderRow } from "./controls";
import ProviderPicker from "./ProviderPicker";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  assistant: Assistant;
};

/** Model (LLM) settings drawer. */
export default function ModelSettings({ open, onOpenChange, assistant }: Props) {
  return (
    <SettingsSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Model"
      description="The LLM that powers the assistant's reasoning and replies."
      icon={<Brain className="size-4 text-sky-500" />}
    >
      <ProviderPicker
        kind="model"
        assistant={assistant}
        current={assistant.llm}
        patchKey="llm_id"
        optionLabel="Model"
      />

      <div className="border-t pt-4">
        <SliderRow
          label="Temperature"
          description="Lower is more deterministic; higher is more creative."
          min={0}
          max={1}
          step={0.1}
          defaultValue={0.5}
          minLabel="Precise"
          maxLabel="Creative"
          format={(v) => v.toFixed(1)}
        />
      </div>

      <div className="border-t pt-4">
        <Field
          label="Max tokens"
          hint="Cap on how much the assistant generates per turn."
        >
          <Input type="number" defaultValue={250} className="h-9" />
        </Field>
      </div>
    </SettingsSheet>
  );
}
